<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Defaults</h6>
            </div>
          </header>
          <div class="vs-card--content text-center con-select-example">
            <div class="con-notifications">
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Default',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                  })
                "
                color="primary"
                type="border"
                >Notification white</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Primary',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'primary',
                  })
                "
                color="primary"
                type="flat"
                >Notification Primary</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Success',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'success',
                  })
                "
                color="success"
                type="flat"
                >Notification Success</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Danger',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'danger',
                  })
                "
                color="danger"
                type="flat"
                >Notification Danger</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Warning',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'warning',
                  })
                "
                color="warning"
                type="flat"
                >Notification Warning</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'dark',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'dark',
                  })
                "
                color="dark"
                type="flat"
                >Notification Dark</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="random()"
                color="success"
                type="gradient"
                >Notification Random Color</vs-button
              >
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Positions</h6>
            </div>
          </header>
          <div class="vs-card--content con-select-example">
            <div class="con-notifications-position">
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Position Default',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'primary',
                  })
                "
                color="primary"
                type="flat"
                >Position Default</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Position top-right',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'success',
                    position: 'top-right',
                  })
                "
                color="success"
                type="flat"
                >Position Top Right</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Position top-left',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'danger',
                    position: 'top-left',
                  })
                "
                color="danger"
                type="flat"
                >Position Top Left</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Position bottom-left',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'warning',
                    position: 'bottom-left',
                  })
                "
                color="warning"
                type="flat"
                >Position Bottom Left</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="
                  $vs.notify({
                    title: 'Position bottom-center',
                    text: 'Lorem ipsum dolor sit amet, consectetur',
                    color: 'dark',
                    position: 'bottom-center',
                  })
                "
                color="dark"
                type="flat"
              >
                Position Bottom Center</vs-button
              >
              <vs-button
                class="mx-2 mb-2"
                @click="randomCenter()"
                color="success"
                type="gradient"
                >Position Top Center Random Color</vs-button
              >
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icons</h6>
            </div>
          </header>
          <div class="vs-card--content con-select-example">
            <div class="centerx">
    <vs-button class="mx-2 mb-2" @click="$vs.notify({title:'Icon mail',text:'Lorem ipsum dolor sit amet, consectetur',color:'primary',icon:'mail'})" color="primary" type="flat">Icon Mail</vs-button>
    <vs-button class="mx-2 mb-2" @click="$vs.notify({title:'Icon mail',text:'Lorem ipsum dolor sit amet, consectetur',color:'success',icon:'check_box'})" color="success" type="flat">Icon check_box</vs-button>
    <vs-button class="mx-2 mb-2" @click="$vs.notify({title:'Icon mail',text:'Lorem ipsum dolor sit amet, consectetur',color:'danger',icon:'favorite'})" color="danger" type="flat">Icon favorite</vs-button>
    <vs-button class="mx-2 mb-2" @click="$vs.notify({title:'Icon mail',text:'Lorem ipsum dolor sit amet, consectetur',color:'warning',icon:'error'})" color="warning" type="flat">Icon error</vs-button>
    <vs-button class="mx-2 mb-2" @click="$vs.notify({title:'Icon mail',text:'Lorem ipsum dolor sit amet, consectetur',color:'dark',icon:'chat'})" color="dark" type="flat">Icon chat</vs-button>
    <vs-button class="mx-2 mb-2" @click="randomIcon()" color="success" type="gradient">Icon Random Color</vs-button>
  </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
    random() {
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      let color = `rgb(${getRandomInt(0, 255)},${getRandomInt(
        0,
        255
      )},${getRandomInt(0, 255)})`;

      this.$vs.notify({
        title: "Color",
        text: "Lorem ipsum dolor sit amet, consectetur",
        color: color,
      });
    },
    randomCenter() {
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      let color = `rgb(${getRandomInt(0, 255)},${getRandomInt(
        0,
        255
      )},${getRandomInt(0, 255)})`;
      this.$vs.notify({
        title: "Position top-center",
        text: "Lorem ipsum dolor sit amet, consectetur",
        color: color,
        position: "top-center",
      });
    },
     randomIcon(){
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      let color = `rgb(${getRandomInt(0,255)},${getRandomInt(0,255)},${getRandomInt(0,255)})`

      this.$vs.notify({title:'Icon mail',text:'Lorem ipsum dolor sit amet, consectetur',color:color,icon:'verified_user'})
    }
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({}),
};
</script>
